// CLP formatting helpers — Chilean peso with thousand separator
// Usage: formatCLP(9999999) → "$9.999.999"
// Also accepts already-formatted strings like "$9.999.999" and re-normalizes.

// Marker used in seed/test data — when a product carries this value it means
// "no real price loaded yet; the public UI should show 'Cotizar' instead".
export const PRICE_PLACEHOLDER = '$9.999.999';

export const isPlaceholderPrice = (value) => {
  if (!value) return false;
  const num = typeof value === 'number' ? value : parseInt(String(value).replace(/[^\d]/g, ''), 10);
  return num === 9999999;
};

export const formatCLP = (value) => {
  if (value === null || value === undefined || value === '') return '';
  let num;
  if (typeof value === 'number') {
    num = value;
  } else {
    // Strip everything except digits — CLP has no decimals, so any "." or "," is a thousand sep
    const clean = String(value).replace(/[^\d]/g, '');
    if (!clean) return '';
    num = parseInt(clean, 10);
  }
  if (isNaN(num)) return '';
  return '$' + new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(num);
};

// Format without currency symbol (for inputs)
export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '';
  let num;
  if (typeof value === 'number') {
    num = value;
  } else {
    const clean = String(value).replace(/[^\d]/g, '');
    if (!clean) return '';
    num = parseInt(clean, 10);
  }
  if (isNaN(num)) return '';
  return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(num);
};

// Parse a formatted string back to number
export const parseCLP = (str) => {
  if (typeof str === 'number') return str;
  if (!str) return 0;
  const clean = String(str).replace(/[^\d]/g, '');
  return parseInt(clean, 10) || 0;
};
